import { createAsyncThunk } from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';


  export const getMyProductAsync = createAsyncThunk('equipmentMinePage/getMyProductAsync', async (data, thunkAPI) => {
        try {
            
            thunkAPI.dispatch(showAppLoader());
            const result = await ProviderManager.getProviderData('getMyProduct', []);
            thunkAPI.dispatch(hideAppLoader());
            return result;
        } catch (error) {
            console.error('getMyProduct error:', error);
            throw error;
        } finally {
            thunkAPI.dispatch(hideAppLoader());
        };
    }
  );
